import {Fragment} from "react";
import {Table, TableBody, TableCell, TableRow} from "@mui/material";
import FormattedTableHead from "../../../FormattedTableHead";
import {defineMessage, FormattedMessage} from "react-intl";
import FormattedRegistrationTime from "../../../FormattedRegistrationTime";
import DeleteButton from "./DeleteButton";
import UpdateButton from "./save/UpdateButton";
import NoDeviceBlock from "../NoDeviceBlock";
import {HasPermission} from "../../../widgets";
import {ClientDevicesQueryHookResult} from "../queries.generated";
import {ClientType} from "@/api";
import {CLIENT_TYPE_MESSAGES} from "@/utils/translations";

type Props = {
    query: ClientDevicesQueryHookResult;
    onMutate: () => void;
};

export default ({query, onMutate}: Props) => {
    const componentId = "extension-client-devices";

    if (!query.data.clientDevices.length) {
        return (
            <div id={componentId}>
                <NoDeviceBlock idSuffix="client" />
            </div>
        );
    }

    function onSuccess() {
        query.refetch();
        onMutate();
    }

    return (
        <Fragment>
            <Table id={componentId}>
                <FormattedTableHead
                    cells={[
                        {label: defineMessage({id: "description", defaultMessage: "Description"})},
                        {label: defineMessage({id: "type", defaultMessage: "Type"})},
                        {label: defineMessage({id: "devices.registrationTime", defaultMessage: "Registered"})},
                    ]}
                />
                <TableBody>
                    {query.data.clientDevices.map((device) => (
                        <TableRow key={device.id}>
                            <TableCell data-path="client-devices.description" data-value={device.description}>
                                {device.description}
                            </TableCell>
                            <TableCell>
                                <FormattedMessage {...CLIENT_TYPE_MESSAGES[device.type as ClientType]} />
                            </TableCell>
                            <TableCell>
                                <FormattedRegistrationTime
                                    registrationTime={device.registrationTime}
                                    expirationTime={device.registrationExpireTime}
                                    clientInfo={device.clientInfo}
                                />
                            </TableCell>
                            <TableCell align="center">
                                <HasPermission name="edit_admin_extension">
                                    <UpdateButton onSuccess={query.refetch} device={device} />
                                </HasPermission>
                                <DeleteButton
                                    id={device.id}
                                    name={device.description}
                                    onSuccess={onSuccess}
                                    dataIdentifier={device.description}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Fragment>
    );
};
